import { Modal, Form, Input, Button } from "antd";
import PropTypes from "prop-types";

import { addPrompt } from "./simple-prompt-studio-api-service";
import { useCustomToolStore } from "../../store/custom-tool-store";
import { getSequenceNumber } from "../../helpers/GetStaticData";
import { useAlertStore } from "../../store/alert-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";

function AddPromptModal({ open, setOpen }) {
  const [form] = Form.useForm();
  const { details, updateCustomTool } = useCustomToolStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  const handleSubmit = (values) => {
    const body = { ...values };
    body["tool_id"] = details?.tool_id;
    body["sequence_number"] = getSequenceNumber(details?.prompts);
    addPrompt(body)
      .then((res) => {
        const data = res?.data;
        const modifiedDetails = { ...details };
        modifiedDetails?.prompts?.push(data);
        updateCustomTool({ details: modifiedDetails });
        form.resetFields();
      })
      .catch((err) => {
        setAlertDetails(handleException(err, "Failed to add prompt"));
      });
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      title="Add New Prompt"
      onCancel={() => setOpen(false)}
      centered
      footer={null}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="prompt_key"
          label="Field name to extract"
          rules={[
            { required: true, message: "Please input the name to extract!" },
          ]}
        >
          <Input placeholder="e.g: customer name, invoice date." />
        </Form.Item>
        <Form.Item
          name="prompt"
          label="Instruction to AI"
          rules={[{ required: true, message: "Please input the prompt!" }]}
        >
          <Input.TextArea
            rows={6}
            placeholder="Provide instructions to AI to tell it what to extract. e.g: extract customer name, extract invoice date, etc."
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

AddPromptModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export { AddPromptModal };
